/* eslint-disable */
import React, { useState } from "react";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
  Pagination,
  Loader,
  Center,
} from "@mantine/core";
import { IconEdit, IconEye, IconPlus, IconSearch } from "@tabler/icons-react";
import { useGetOrganizations } from "api/superAdmin/organizationManagement";
import ActionsBtn from "../../actionBtn/actionBtn";
import ModalOrgForm from "./modalForm/modalForm";
import { useGetUser } from "api/users/getUser";

export default function TableOrg() {
  const { data: user } = useGetUser();
  const [page, setPage] = React.useState(1);
  const limit = 10;
  const [opened, setOpened] = useState(false);

  const handleClose = () => {
    setOpened(false);
  };

  const { data, isLoading, error, isFetching } = useGetOrganizations(
    page,
    limit
  );

  const colors = ["#5c4bff", "#00b894", "#e17055"];
  const cols = ["purple", "green", "orange"];

  if (isLoading)
    return (
      <Center style={{ height: 400 }}>
        <Loader size="lg" />
      </Center>
    );

  if (error) return <div>Error loading organizations.</div>;

  // Handle empty data
  if (!data?.organizations || data.organizations.length === 0) {
    return (
      <Card shadow="sm" radius="md" p="lg" mb={30}>
        <Group position="apart" mb="md">
          <Text weight={700}>Organizations Management</Text>
          <Button
            leftIcon={<IconPlus size={16} />}
            radius="md"
            color="violet"
            onClick={() => setOpened(true)}
          >
            Add Organization
          </Button>
        </Group>
        <Center py={40}>
          <Text color="dimmed">No organizations found</Text>
        </Center>
        <ModalOrgForm opened={opened} onClose={handleClose} />
      </Card>
    );
  }

  const totalPages = data?.pagination?.pages || 1;
  const totalItems = data?.pagination?.total || 0;

  return (
    <Card shadow="sm" radius="md" p="lg" mb={30}>
      <Group position="apart" mb="md">
        <div>
          <Text weight={700}>Organizations Management</Text>
          <Text size="sm" color="dimmed" mt={4}>
            Showing {(page - 1) * limit + 1} -{" "}
            {Math.min(page * limit, totalItems)} of {totalItems} organizations
          </Text>
        </div>
        <Group>
          <TextInput
            placeholder="Search organizations..."
            icon={<IconSearch size={16} />}
            radius="md"
          />
          <Button
            leftIcon={<IconPlus size={16} />}
            radius="md"
            color="violet"
            onClick={() => setOpened(true)}
            loading={isFetching}
          >
            Add Organization
          </Button>
        </Group>
      </Group>

      {isFetching && !isLoading && (
        <Center py={10}>
          <Loader size="sm" />
        </Center>
      )}

      <ScrollArea>
        <Table verticalSpacing="md">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Type</th>
              <th>Employees</th>
              <th>Projects</th>
              {/* <th>Subscription</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.organizations.map((o, ind) => (
              <tr key={o.id} style={{ opacity: o.isDeleted ? 0.6 : 1 }}>
                <td>
                  <Group spacing="sm">
                    <Box
                      sx={{
                        backgroundColor: colors[ind % colors.length],
                        borderRadius: "8px",
                        padding: "8px 12px",
                      }}
                    >
                      <Text weight={700} color="white">
                        {o.name ? o.name.trim().charAt(0).toUpperCase() : ""}
                      </Text>
                    </Box>
                    <Box>
                      <Text fw={600}>{o.name}</Text>
                      <Text size="sm" c="dimmed">
                      {user?.email}
                      </Text>
                      {o.isDeleted && (
                        <Badge size="sm" color="red" mt={4}>
                          Deleted
                        </Badge>
                      )}
                    </Box>
                  </Group>
                </td>
                <td>{o.type}</td>
                <td>{o.employees}</td>
                <td>{o.projects}</td>
                {/* <td>
                  <Badge
                    color={o.subscription === "BASIC" ? "blue" : "violet"}
                    variant="light"
                  >
                    {o.subscription}
                  </Badge>
                </td> */}
                <td>
                  {!o.isDeleted ? (
                    <ActionsBtn organization={o} />
                  ) : (
                    <Badge color="red" variant="light">
                      Deleted
                    </Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ScrollArea>

      {/* Pagination Component */}
      {totalPages > 1 && (
        <Group position="center" mt="xl">
          <Pagination
            total={Math.max(1, totalPages)}
            radius="sm"
            siblings={1}
            page={page}
            onChange={setPage}
          />
        </Group>
      )}

      <ModalOrgForm opened={opened} onClose={handleClose} />
    </Card>
  );
}
